@let form = getForm();
@if (editMode() && form) {
  <div [formGroup]="form">
    <app-detail-row [editMode]="editMode()" label="Kontonummer"
      >{{ konto()?.kontoNummer }}
      <ng-template #editor>
        <p-input-number
          formControlName="kontoNummer"
          locale="da"
          [useGrouping]="false"
          [maxlength]="10"
          [maxFractionDigits]="0"
          mode="decimal" />
      </ng-template>
    </app-detail-row>

    <app-detail-row [editMode]="editMode()" label="Registreringsnummer"
      >{{ konto()?.regNr }}
      <ng-template #editor>
        <p-input-number
          formControlName="regNr"
          locale="da"
          [useGrouping]="false"
          [maxlength]="4"
          [maxFractionDigits]="0"
          mode="decimal" />
      </ng-template>
    </app-detail-row>

    <app-detail-row [editMode]="editMode()" label="Navn"
      >{{ konto()?.navn }}
      <ng-template #editor>
        <input pInputText formControlName="navn" />
      </ng-template>
    </app-detail-row>

    <app-detail-row [editMode]="editMode()" label="Skyggesaldo"
      >{{ konto()?.skyggesaldoType }}
      <ng-template #editor>
        <p-select
          [options]="skyggesaldoOptions"
          class="w-[178px]"
          formControlName="skyggesaldoType"
          optionLabel="text"
          optionValue="value"
          [showClear]="true"
          appendTo="body" />
      </ng-template>
    </app-detail-row>
  </div>
} @else {
  <app-detail-row [editMode]="editMode()" label="Kontonummer"
    >{{ konto()?.kontoNummer }}
  </app-detail-row>

  <app-detail-row [editMode]="editMode()" label="Registreringsnummer"
    >{{ konto()?.regNr }}
  </app-detail-row>

  <app-detail-row [editMode]="editMode()" label="Navn"
    >{{ konto()?.navn }}
  </app-detail-row>

  <app-detail-row [editMode]="editMode()" label="Skyggesaldo"
    >{{ konto()?.skyggesaldoType }}
  </app-detail-row>
}
